import aaPartnershipSaga from './airAmbulance';

const partnershipSagasRoot = [aaPartnershipSaga()];

export default partnershipSagasRoot;
